import cx from "classnames";
import React, { useRef } from "react";
import { JobWarning } from "../../../../common/api/v1.1/types/jobs";

import { StateCallbacks } from "../state";
import { State } from "../types";
import { Question } from "./Question";
import { useScrollToQuestion } from "./useScrollToQuestion";

type Props = Readonly<{
  review: boolean;
  state: State;
  stateCallbacks: StateCallbacks;
  focusWarningsTab: () => void;
  warnings: JobWarning[];
}>;

export const Questions = ({ review, state, stateCallbacks, focusWarningsTab, warnings }: Props) => {
  const { activeValue, taxonomy, values } = state;
  const questionListRef = useRef(null);

  useScrollToQuestion(
    questionListRef,
    state.activeValue in state.values ? state.activeValue : null,
  );
  return (
    <div className="h-100 overflow-auto" ref={questionListRef}>
      <div className={cx({ "border-top": !review, "border-left": review })}>
        {taxonomy.taxonomyObject.map(entry => {
          return (
            <Question
              active={activeValue}
              confidenceThreshold={state.confidenceThreshold}
              taxonomyEntry={entry}
              key={entry.key}
              review={review}
              stateCallbacks={stateCallbacks}
              taxonomy={taxonomy}
              values={values}
              blocks={state.blocks}
              focusWarningsTab={focusWarningsTab}
              warnings={warnings}
            />
          );
        })}
      </div>
    </div>
  );
};
Questions.displayName = "Questions";
